<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Ukryty tytuł',
              modelPath: [this, 'form', 'is_title_hidden']
            }),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.WYSIWYG({
              label: 'Tekst',
              modelPath: [this, 'form', 'text'],
              multilingual: true
            }),
            new fields.Header({
              text: 'Bilety'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item.link, ['url']),
                fields: [
                  new fields.Image({
                    label: 'Zdjęcie',
                    modelPath: [this, 'form', 'items', i, 'image'],
                    required: true
                  }),
                  new fields.Link({
                    label: 'Odnośnik',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'link'],
                    labelPlaceholder: 'Tekst wyświetlany przy przycisku'
                  }),
                  new fields.Input({
                    label: 'Podpis',
                    modelPath: [this, 'form', 'items', i, 'caption'],
                    multilingual: true
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
